import React, { useState } from "react";

import { ChevronTopOutline } from "@olist/design-system-icons";

import {
  AccordionContent,
  AccordionHeader,
  AccordionWrapper,
  Icon,
} from "./styles";

interface IAccordionProps {
  title: string;
  children: React.ReactNode;
  isPreviousOpen: boolean;
  onClickTrack?: () => void;
}

export function Accordion({
  children,
  isPreviousOpen,
  onClickTrack,
  title,
}: IAccordionProps) {
  const [isOpen, setIsOpen] = useState(isPreviousOpen);

  const handleOpen = () => {
    setIsOpen(!isOpen);
    onClickTrack?.();
  };

  return (
    <AccordionWrapper>
      <AccordionHeader onClick={handleOpen} isOpen={isOpen}>
        {title}
        <Icon isOpen={isOpen}>
          <ChevronTopOutline />
        </Icon>
      </AccordionHeader>
      <AccordionContent isOpen={isOpen}>
        <div style={{ padding: "10px" }}>{children}</div>
      </AccordionContent>
    </AccordionWrapper>
  );
}
